// react
import { useContext } from 'react';

// context
import { ContextBeneficiaryCashBenefits } from '../Beneficiary.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableCashBenefits } from '../../../tables/cards/TableCashBenefits/TableCashBenefits';

export const CashBenefits = () => {
	// context
	const { isLoadingCashBenefits, paginationCashBenefits, cashBenefits, refetchCashBenefits } =
		useContext(ContextBeneficiaryCashBenefits);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableCashBenefits
						frame={'BENEFICIARY'}
						isLoading={isLoadingCashBenefits}
						pagination={paginationCashBenefits}
						refetchTransactions={refetchCashBenefits}
						transactions={cashBenefits}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
